<template>
  <div>
    <div class="row m-0 fixed-bottom time rtl" style="
        height: 50px;
        max-width: 590px;
        margin: 0 auto !important;
        z-index: 2;
      ">
      <div class="col-3 text-center errorsTimeMap pl-0">
        {{ errorNumber }}
        <span id="erreurs">{{ lang }}{{ translation.mistakes }}</span>
      </div>
      <div class="col-4 text-center errorsTimeMap pl-1">
        {{ pointNumForEvolution }}/{{ Object.values(pointsArrayOrder).length }}
        <span id="evolution">התקדמות</span>
      </div>
      <div class="col-5 text-center errorsTimeMap pr-0">
        {{ pointsScore }}
        <span id="runningTime">{{ translation.pointsScore }}</span>
      </div>
    </div>

    <div v-if="rowPhotoMissingWord" style="
        display: block;
        margin: 0px;
        padding: 0px;
        min-height: calc(100vh - 150px);
        margin-bottom: 55px;
      " class="mt-4 container d-flex">
      <div class="row p-0 m-0" style="max-width: 590px">
        <!-- ****************************************************************** -->
        <div class="sentenceAboveMap mb-3" :style="variableBackgroundColor">
          <div v-if="pointNum === 0">
            {{ translation.goToFirstPoint }}
          </div>
          <div v-else>
            {{ translation.followThePath }}
          </div>
        </div>

        <div id="map2" :style="variableBackgroundColor">
          <map />
          <GMapMap v-if="showMap" :center="center" :zoom="Number(mapParameters.zoom)" map-type-id="satellite" :tilt="0"
            style="width: 100vw; height: 50vh" :styles="myMapStyle" :options="{
              zoomControl: false,
              mapTypeControl: true,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: true,
              fullscreenControl: false,
              disableDefaultUi: false,
            }">
            <GMapPolyline v-if="noGoogleRouteArray[pointNum]" :path="wayPoints[pointNum]" :options="{
              geodesic: true,
              strokeColor: '#5C81C4',
              strokeWeight: 5,
              strokeOpacity: 0.8
            }" />
            <!-- <PolylineMap v-if="noGoogleRouteArray[pointNum]" :path="wayPoints[pointNum]" :editable="false" :options="{
                strokeColor: '#5C81C4',
                strokeWeight: 5,
                strokeOpacity: 0.8,
              }" /> -->
            <DirectionsRenderer v-else travelMode="WALKING" :origin="startLocation" :destination="endLocation"
              :waypoints="wayPoints[pointNum]" :icon="iconImage" />

            <GMapMarker v-if="showPosMarker" :clickable="true" @click="center = m.position"
              :position="myCurrentPosition" :icon="iconImage" />
            <GMapMarker style="margin-right: 10px !important" :key="index" v-for="(m, index) in twoMarkersArray"
              :position="m" :clickable="true" :draggable="false"
              :label="{ text: `${index + 1}`, color: 'white', fontSize: '9px' }" @click="center = m" />
          </GMapMap>
        </div>
        <!-- <div v-if="showtextEncouragement" class="textEncouragement">
          <span class="appearSlowly">{{ textEncouragement }}</span>
        </div> -->
        <!-- ****************************************************************** -->
        <div class="g-container" :style="variableBackgroundColor">
          <div class="g-contrast" :style="variableBackgroundColor">
            <div class="g-bubbles">
              <div class="bubbles"></div>
              <div class="bubbles"></div>
              <div class="bubbles"></div>
              <div class="bubbles"></div>
            </div>
            <div class="g-circle" :style="variableBackgroundColor"></div>
          </div>
        </div>
        <div class="
            row
            align-items-center
            justify-content-center
            align-self-center
            m-0
            p-0
          " style="
            min-height: 15%;
            width: 100vw;
            margin-bottom: 50px !important;
            height: 50px;
            top: -145px;
            position: relative;
          ">
          <div v-if="!reachedThePoint" class="checkLocationButtonDisabeld rtl text-center mt-4">
            <span v-if="!showTimmer">
              {{ buttonName }}
            </span>
            <div id="timer" class="h2 text-center" v-else></div>
            <div id="explosionDiv" v-if="showExplosion">
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
            </div>
            <!-- <RunningTime v-else /> -->
          </div>
          <div v-else class="checkLocationButton rtl text-center mt-4" @click="checkLocation"
            :style="variableBackgroundColor">
            <span v-if="!showTimmer">
              {{ buttonName }}
            </span>
            <div id="timer" class="h2 text-center" v-else></div>
            <div id="explosionDiv">
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
              <div class="explosion"></div>
            </div>

            <!-- <RunningTime v-else /> -->
          </div>
          <div class="col-2 pl-2" style="
              font-size: 30px;
              color: #5954b0;
              margin-top: 11px;
              position: fixed;
              bottom: 59px;
              left: 4px;
            " @click="showAlertSkipPoint">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor"
              class="bi bi-skip-backward-fill" viewBox="0 0 16 16">
              <path
                d="M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V8.753l6.267 3.636c.54.313 1.233-.066 1.233-.697v-2.94l6.267 3.636c.54.314 1.233-.065 1.233-.696V4.308c0-.63-.693-1.01-1.233-.696L8.5 7.248v-2.94c0-.63-.692-1.01-1.233-.696L1 7.248V4a.5.5 0 0 0-.5-.5z" />
            </svg>
          </div>
          <!-- <div
            class="font-weight-bold h6 text-center"
            style="width: 100%"
            @click="reachedThePoint = true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              fill="currentColor"
              class="bi bi-skip-backward-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V8.753l6.267 3.636c.54.313 1.233-.066 1.233-.697v-2.94l6.267 3.636c.54.314 1.233-.065 1.233-.696V4.308c0-.63-.693-1.01-1.233-.696L8.5 7.248v-2.94c0-.63-.692-1.01-1.233-.696L1 7.248V4a.5.5 0 0 0-.5-.5z"
              />
            </svg>
          </div> -->
        </div>
      </div>
    </div>

    <div id="questionDiv" v-if="rowPhotoMissingWord === false" style="display: block" align="center">
      <div class="my-5 px-1">
        <p class="question px-3 text-right rtl">
          {{ questionSuffled[questionNumber].question }}
        </p>
      </div>
      <div class="mb-5 rtl">
        <div :key="answer.id" v-for="answer in getAnswerArray">
          <!-- <button
            class="fullWidth colorBtn btn font-weight-bold mb-3"
            style="background-color: #4f9e2c"
            @click="checkAnswer(answer)"
          > -->
          <button class="fullWidth colorBtn btn font-weight-bold mb-3" style="background-color: rgb(139 135 206)"
            @click="checkAnswer(answer)">
            {{ answer }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showPointInformation === true && rowPhotoMissingWord === false" class="over">
      <div class="p-3 mb-5 modalInformationPoint rtl">
        <!-- <div class="container h-100 d-flex"> -->
        <div class="row" style="min-height: 100vh">
          <!-- <div class="col-12 d-flex align-items-start">
              <div class="mb-4 text-right rtl">
                <strong>{{ translation.didYouKnow }}</strong>
              </div>
            </div> -->

          <div class="col-12 align-self-center text-right rtl" style="height: 20%">
            <!-- <div class="mt-1 mb-4">
              <audio
                v-if="
                  Object.values(this.points)[
                    this.pointsArrayOrder[this.pointNum] - 1
                  ].audioUrl
                "
                id="audio"
                controls
                autoplay
              >
                <source :src="audioSrc" type="audio/mp3" />
              </audio>
            </div> -->
            <!-- <div v-if="points[pointNum + 1].videoUrl"> -->
            <YouTube v-if="points[pointNum + 1].withVideo" :video-id="videoId" :player-vars="playerVars"
              @playing="playing" style="position: relative; width: 92vw; left: 12px"></YouTube>
            <!-- </div> -->

            <div style="white-space: pre-line; font-size: 18px" v-else>
              <!-- {{
                  Object.values(this.points)[
                    this.pointsArrayOrder[this.pointNum] - 1
                  ].pointInformation
                }} -->

              {{ newInformationPointString }}
            </div>
          </div>
          <div class="col-12 d-flex align-items-end" style="height: 20%">
            <button v-if="showButtonInfoScreen" class="mainButton btn font-weight-bold mt-3 rtl"
              style="background-color: rgb(119, 190, 87); margin-bottom: 50px" @click="fadeInDiv">
              {{ translation.goToQuestions }}
            </button>
            <button v-else class="mainButton btn font-weight-bold mt-3 rtl"
              style="background-color: rgb(119, 190, 87); margin-bottom: 50px" disabled>
              {{ translation.goToQuestions }}
            </button>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>

    <div v-if="alertSkipPoint" class="over">
      <div class="myModal p-4 mb-5 red container d-flex">
        <div class="row justify-content-center align-self-center">
          <div class="h5 mb-4 text-center col-12 rtl">
            {{ translation.skipPointBeware }}
          </div>
          <div class="col-6">
            <div class="font-weight-bold h6 text-center" style="width: 100%" @click="
              skipPoint();
            hideImageQuestion();
            ">
              {{ translation.skipPoint }}
            </div>
          </div>
          <div class="col-6">
            <div class="font-weight-bold h6 text-center" style="
                width: 100%;
                padding-top: 9px;
                color: red;
                background: white;
                height: 38px;
                border-radius: 30px;
              " @click="alertSkipPoint = false">
              {{ translation.back }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogCorrectAnswer" class="over">
      <!-- <div
        class="myModal p-4 mb-5 green container d-flex"
        @click="hideImageQuestion"
      > -->
      <div class="myModal p-4 mb-5 container d-flex" style="background: #2fcf17" @click="hideImageQuestion">
        <div class="row justify-content-center align-self-center">
          <audio id="audio" controls autoplay style="display: none">
            <source src="../../static/sounds/applause.mp3" type="audio/mp3" />
          </audio>
          <div class="h2 mb-4 text-center col-12 rtl" style="font-family: 'noot'">
            {{ translation.wellDone }}
          </div>
          <div class="mb-4 text-center h4 col-12 rtl font-weight-bold">
            {{ translation.correctAnswer }}
          </div>
          <div class="col-12">
            <div class="fullWidth font-weight-bold h4 text-center rtl" style="background-color: #2fcf17; width: 100%">
              {{ translation.continue }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogWrongAnswer" class="over">
      <div class="myModal p-4 mb-5 red container d-flex" @click="dialogWrongAnswer = false">
        <div class="row justify-content-center align-self-center" style="color: white; background: #d41a1b">
          <div class="col-12 h2 mb-4 text-center rtl" style="font-family: 'noot'">
            הופאהה!
          </div>
          <div class="col-12 mb-4 text-center rtl">
            {{ translation.wrongAnswer }}
          </div>
          <audio id="audio" controls autoplay style="display: none">
            <source src="../../static/sounds/boo.mp3" type="audio/mp3" />
          </audio>

          <div class="fullWidth font-weight-bold h3 text-center rtl" style="width: 100%">
            {{ translation.tryAgain }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="showLastDialog" class="over container d-flex">
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="
          myModal
          p-2
          #5954B0
          d-flex
          row
          justify-content-center
          align-self-center align-items-center
          mt-0
        " style="background: #3939f3" @click="showResults">
        <audio id="audio" controls loop autoplay style="display: none">
          <source src="../../static/sounds/Champions.mp3" type="audio/mp3" />
        </audio>
        <div class="h4 p-2 col-12 text-center rtl" style="font-family: 'noot'">
          כל הכבוד {{ userName }}!
        </div>
        <div class="p-2 col-12 text-right rtl">
          {{ translation.visitOf }}
          <!-- {{ gameParameters.navigationName.toUpperCase() }}! -->
        </div>
        <div class="border border-white px-4 py-2">
          <div class="p-2 col-12 font-weight-bold text-right rtl">
            {{ translation.yourResults }}
          </div>
          <div class="p-2 col-12 font-italic text-right rtl">
            {{ translation.errorNumber }} {{ errorNumber }}
          </div>
          <div class="p-2 col-12 font-italic text-right rtl">
            {{ translation.totalTime }} {{ gameSecondToTime }}
          </div>
        </div>

        <div class="p-2 col-12 text-right rtl">
          {{ translation.goToRanking }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
// import { gmapApi } from "vue2-google-maps";
// import map from "./map";
// import RunningTime from "./runningTime.vue";

import DirectionsRenderer from '@/components/DirectionsRenderer.vue'// import PolylineMap from "../polyline";

export default {
  // components: { DirectionsRenderer, PolylineMap, RunningTime },
  // components: { DirectionsRenderer, PolylineMap },
  components: { DirectionsRenderer },

  computed: {
    // google: gmapApi,
  },
  data() {
    return {
      showExplosion: false,
      pointsScore: 0,
      min: 0,
      sec: 0,
      showTimmer: false,
      // videoId: "lG0Ys-2d4MA",
      playerVars: {
        autoplay: 1,
      },
      showMap: true,
      noGoogleRouteArray: [],
      gettingClosed: false,
      showtextEncouragement: true,
      textEncouragement: "",
      textEncouragementArray: [
        "אתם בדרך הנכונה",
        "הכפתור יופיע כשתגיעו למקום",
        "תמשיכו ללכת לפי המסלול",
      ],
      textEncouragementArrayClose: [
        "אתם קרובים !",
        "עוד מעט מגיעים",
        "מעולים אתם !",
        "עוד מעט תראו את הכפתור",
        "יופי של קצב",
      ],
      showDots: true,
      buttonNameNotThere: "",
      reachedThePoint: false,
      rangeInPosition: 0.0003,
      buttonName: "בדרך",
      backgroundButttonColor: "#736df2",
      currentPlace: null,
      places: [],
      startLocation: null,
      endLocation: null,
      alertSkipPoint: false,
      imageUrl: "",
      showPosMarker: false,
      showButtonInfoScreen: false,
      iconImage: {
        url: require("../../static/img/circle.png"),
      },
      watchPositionId: null,
      position: { lat: null, lng: null },
      showCurrentPositionButton: true,
      myCurrentPosition: "",
      myMapStyle: {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      firstQuestion: 1,
      showPointInformation: false,
      secondsToTime: "00:00:00",
      gameSecondToTime: "",
      totalSeconds: 0,
      startTime: Date.now(),
      endTime: "",
      showLastDialog: false,
      key: "",
      questiomMultipleChoices: true,
      rowPhotoMissingWord: true,
      dialogWrongAnswer: false,
      dialogCorrectAnswer: false,
      loading: false,
      src: "",
      timeNow: "",
      questionNumber: -1,
      errorNumber: 0,
      pointNum: 0,
      pointNumForEvolution: 1,
      letter: "",
      allLetters: "",
      gameTimeInSecond: "",
      userKey: "",
      translationMissingWord: "Mot manquant sur l'image",
      translation: "",
    };
  },
  mounted() {
    if (this.showTimmer) {
      this.countDownSeconds(this.min, this.sec);
    }

    this.checkNoGoogleRoute();
    if (this.gameParameters) {
      console.log("ok");
    } else {
      console.log("bug");
      this.reopenGame();
    }
    this.userKey = localStorage.getItem("userKey");
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
    this.countSeconds();
    this.changeButton();
    // this.startBubble();
    setTimeout(() => {
      this.addMarker();
      this.showCurrentPosition();
      // this.showMapTrue();
    }, 1000);

    if (localStorage.getItem("questionNumber")) {
      if (localStorage.getItem("pointNumberOuchui")) {
        this.pointNum = localStorage.getItem("pointNumberOuchui");
        this.pointNumForEvolution = localStorage.getItem(
          "pointNumForEvolutionOuchui"
        );
      } else {
        this.pointNum = 0;
        this.pointNumForEvolution = 1;
      }
      this.startTime = localStorage.getItem("startTimeOuchui");
      if (localStorage.getItem("errorNumber")) {
        this.errorNumber = localStorage.getItem("errorNumber");
      } else {
        this.errorNumber = 0;
      }
      this.questionNumber = JSON.parse(localStorage.getItem("questionNumber"));
      this.firstQuestion = localStorage.getItem("firstQuestion");
      this.rowPhotoMissingWord = JSON.parse(
        localStorage.getItem("rowPhotoMissingWord")
      );
      console.log("this.pointNumn", this.pointNum);
    }
  },
  computed: {
    videoId() {
      console.log(
        "this.points[this.pointNum + 1].videoUrl",
        this.points[this.pointNum + 1].videoUrl
      );
      return this.points[this.pointNum + 1].videoUrl;
    },
    // timePerPoint() {
    //   console.log(
    //     "this.points[this.pointNum + 1].timePerPoint",
    //     this.points[this.pointNum + 1].timePerPoint
    //   );
    //   return this.points[this.pointNum + 1].timePerPoint;
    // },
    twoMarkersArray() {
      if (this.pointNum == 0) {
        var oneMarkerArrray = [
          {
            lat: this.markers[this.pointNum].position.lat,
            lng: this.markers[this.pointNum].position.lng,
          },
        ];
        return oneMarkerArrray;
      } else {
        var twoMarkersArray = [
          {
            lat: this.markers[this.pointNum - 1].position.lat,
            lng: this.markers[this.pointNum - 1].position.lng,
          },
          {
            lat: this.markers[this.pointNum].position.lat,
            lng: this.markers[this.pointNum].position.lng,
          },
        ];
        return twoMarkersArray;
      }
    },
    center() {
      if (this.pointNum == 0) {
        var center = {
          lat: Number(this.markers[this.pointNum].position.lat),
          lng: Number(this.markers[this.pointNum].position.lng),
        };
      } else {
        var center = {
          lat:
            (Number(this.markers[this.pointNum - 1].position.lat) +
              Number(this.markers[this.pointNum].position.lat)) /
            2,
          lng:
            (Number(this.markers[this.pointNum - 1].position.lng) +
              Number(this.markers[this.pointNum].position.lng)) /
            2,
        };
      }
      return center;
    },
    variableBackgroundColor() {
      return {
        "--buttonColor": this.backgroundButttonColor,
      };
    },
    newInformationPointString() {
      return this.points[
        this.pointsArrayOrder[this.pointNum]
      ].pointInformation.replaceAll("\n", "\n");
    },
    audioSrc() {
      if (
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .audioUrl
      ) {
        return Object.values(this.points)[
          this.pointsArrayOrder[this.pointNum] - 1
        ].audioUrl;
      } else {
        return null;
      }
    },
    numberOfQUestionPerPoint() {
      // console.log(
      //   "this.$store.getters.questionsShuffled.length",
      //   this.$store.getters.questionsShuffled.length
      // );
      // console.log(
      //   "Math.floor(this.$store.getters.questionsShuffled.length /this.$store.getters.points.length);",
      //   this.$store.getters.questionsShuffled.length
      // );
      // console.log(
      //   "this.$store.getters.points.length",
      //   this.$store.getters.points.length
      // );

      return Math.floor(
        this.$store.getters.questionsShuffled.length /
        (this.$store.getters.points.length - 1)
      );
    },
    lang() {
      // console.log("this.$store.getters.lang", this.$store.getters.lang);
      return this.translate(this.$store.getters.lang);
    },
    userName() {
      return this.$store.getters.user.userName;
    },
    mapParameters() {
      return this.$store.getters.mapParameters;
    },
    gameParameters() {
      return this.$store.getters.gameParameters;
    },
    group() {
      return this.$store.getters.group;
    },
    points() {
      console.log("this.$store.getters.points", this.$store.getters.points);
      return this.$store.getters.points;
    },
    markers() {
      if (localStorage.getItem("markers")) {
        var markers = JSON.parse(localStorage.getItem("markers"));
        // console.log("markers", markers);
      } else {
        var markers = this.$store.getters.markers;
        // console.log("markers", markers);
      }
      // var markers = this.$store.getters.markers;
      var markersArray = [];
      markers.forEach((marker) => {
        if (marker != null) {
          markersArray.push({ position: { lat: marker.lat, lng: marker.lng } });
        }
      });
      return markersArray;
    },
    wayPoints() {
      if (localStorage.getItem("wayPoints")) {
        var wayPoints = JSON.parse(localStorage.getItem("wayPoints"));
        // console.log("wayPoints", wayPoints);
      } else {
        var wayPoints = this.$store.getters.wayPoints;
        // console.log("wayPoints", wayPoints);
      }
      var wayPointsArray = [];
      wayPoints.forEach((wayPoint) => {
        if (wayPoint != null) {
          wayPointsArray.push(wayPoint);
        }
      });
      // console.log("wayPointsArray", wayPointsArray);
      return wayPointsArray;
    },
    questions() {
      return this.$store.getters.questions;
    },
    getImgUrl() {
      if (
        Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
          .imageBase64
      ) {
        return Object.values(this.points)[
          this.pointsArrayOrder[this.pointNum] - 1
        ].imageBase64;
      } else {
        return Object.values(this.points)[
          this.pointsArrayOrder[this.pointNum] - 1
        ].imageUrl;
      }
    },
    pointsArrayOrder() {
      if (localStorage.getItem("pointsArrayOrder")) {
        return JSON.parse(localStorage.getItem("pointsArrayOrder"));
      } else {
        return this.$store.getters.pointsArrayOrder;
      }
    },
    questionSuffled() {
      if (localStorage.getItem("questionSuffled")) {
        return JSON.parse(localStorage.getItem("questionSuffled"));
      } else {
        return this.$store.getters.questionsShuffled;
      }
    },
    getAnswerArray() {
      let answerArray;
      answerArray = [
        this.questionSuffled[this.questionNumber].wrongAnswer1,
        this.questionSuffled[this.questionNumber].wrongAnswer2,
        this.questionSuffled[this.questionNumber].wrongAnswer3,
        this.questionSuffled[this.questionNumber].correctAnswer,
      ];
      let currentIndex = answerArray.length,
        temporaryValue,
        randomIndex;
      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = answerArray[currentIndex];
        answerArray[currentIndex] = answerArray[randomIndex];
        answerArray[randomIndex] = temporaryValue;
      }
      return answerArray;
    },
  },

  methods: {
    countDownSeconds(min, sec) {
      this.min = this.timePerPoint;
      var countDown = setInterval(() => {
        if ((this.min == 0 && this.sec == 1) || this.reachedThePoint == true) {
          this.addScorePoints();
          clearInterval(countDown);
          console.log("timeFinished");
        }
        if (this.sec == 0) {
          this.min--;
          // this.min--;
          sec = 60;
        }
        sec--;
        this.sec = sec;
        if (sec > 9) {
          document.getElementById("timer").innerHTML =
            "0" + this.min + ":" + sec;
        } else {
          document.getElementById("timer").innerHTML =
            "0" + this.min + ":" + "0" + sec;
        }
      }, 1000);
    },
    addScorePoints() {
      console.log("this.min", this.min);
      var totalPoints = this.min * 60 + this.sec;
      var addScorePoints = setInterval(() => {
        if (this.pointsScore < totalPoints) {
          this.showExplosion = true;
          this.pointsScore++;
        } else {
          setTimeout(() => {
            this.showExplosion = false;
          }, 1000);

          clearInterval(addScorePoints);
        }
      }, 20);
      var countTimeToZero = setInterval(() => {
        if (this.min == 0 && this.sec == 0) {
          clearInterval(countTimeToZero);
        } else {
          if (this.sec == 0) {
            this.min--;
            this.sec = 60;
          }
          this.sec--;
          if (this.sec > 9) {
            document.getElementById("timer").innerHTML =
              "0" + this.min + ":" + this.sec;
          } else {
            document.getElementById("timer").innerHTML =
              "0" + this.min + ":" + "0" + this.sec;
          }
        }
      }, 20);
    },
    playing() {
      console.log("o/ we are watching!!!");
    },
    showMapTrue() {
      this.showMap = true;
    },
    checkNoGoogleRoute() {
      var noGoogleRouteArray = [];
      this.points.forEach((point) => {
        if (point.noGoogleRoute == true) {
          noGoogleRouteArray.push(true);
        } else {
          noGoogleRouteArray.push(false);
        }
      });

      this.noGoogleRouteArray = noGoogleRouteArray;
      console.log("this.noGoogleRouteArray", this.noGoogleRouteArray);
    },
    reopenGame() {
      if (localStorage.getItem("navigationName")) {
        if (localStorage.getItem("pointNumberOuchui")) {
          this.$router.push("/" + localStorage.getItem("navigationName"));
          location.reload();
        } else {
          this.$router.push("/" + localStorage.getItem("navigationName"));
          localStorage.clear();
          location.reload();
        }
      } else {
        localStorage.clear();
        this.$router.push("/");
        location.reload();
      }
    },
    changeButton() {
      setInterval(() => {
        this.showtextEncouragement = !this.showtextEncouragement;
        if (this.gettingClosed) {
          this.textEncouragement =
            this.textEncouragementArrayClose[
            Math.floor(
              Math.random() * this.textEncouragementArrayClose.length
            )
            ];
        } else {
          this.textEncouragement =
            this.textEncouragementArray[
            Math.floor(Math.random() * this.textEncouragementArray.length)
            ];
        }
      }, 5000);
      var checkPosition = setInterval(() => {
        let markerLat = this.markers[this.pointNum].position.lat;
        let markerLng = this.markers[this.pointNum].position.lng;
        if (
          markerLat > this.myCurrentPosition.lat - this.rangeInPosition &&
          markerLat < this.myCurrentPosition.lat + this.rangeInPosition &&
          markerLng > this.myCurrentPosition.lng - this.rangeInPosition &&
          markerLng < this.myCurrentPosition.lng + this.rangeInPosition
        ) {
          this.backgroundButttonColor = "green";
          this.buttonName = "הגענו!";
          this.reachedThePoint = true;
          clearInterval(checkPosition);
        } else {
          if (
            markerLat > this.myCurrentPosition.lat - 0.001 &&
            markerLat < this.myCurrentPosition.lat + 0.001 &&
            markerLng > this.myCurrentPosition.lng - 0.001 &&
            markerLng < this.myCurrentPosition.lng + 0.001
          ) {
            this.backgroundButttonColor = "#f2a100";
            this.gettingClosed = true;
            this.buttonName = "מתקרבים!";
            this.reachedThePoint = false;
          } else {
            this.backgroundButttonColor = "#736df2";
            this.buttonName = "בדרך";
            this.reachedThePoint = false;
          }
        }
      }, 3000);
    },

    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.pointNum == 0) {
        const marker1 = {
          lat: this.markers[0].position.lat,
          lng: this.markers[0].position.lng,
        };
        const marker2 = {
          lat: this.markers[0].position.lat,
          lng: this.markers[0].position.lng,
        };
        console.log("marker1 - marker2", marker1, marker2);
        this.startLocation = marker1;
        this.endLocation = marker2;
        // console.log(
        //   "startLocation - endLocation",
        //   this.startLocation,
        //   this.endLocation
        // );
      } else {
        const marker1 = {
          lat: this.markers[this.pointNum - 1].position.lat,
          lng: this.markers[this.pointNum - 1].position.lng,
        };
        const marker2 = {
          lat: this.markers[this.pointNum].position.lat,
          lng: this.markers[this.pointNum].position.lng,
        };
        this.startLocation = marker1;
        this.endLocation = marker2;
        console.log("marker1 - marker2 NOT FIRST POINT", marker1, marker2);
      }
    },
    skipPoint() {
      this.alertSkipPoint = false;
      this.startTime = this.startTime - 60 * 10 * 1000;
      // this.dialogCorrectAnswer = true;
      localStorage.setItem("pointNumberOuchui", this.pointNum);
      localStorage.setItem(
        "pointNumForEvolutionOuchui",
        this.pointNumForEvolution
      );
      this.$store.dispatch("addEvolutionToDB", {
        pointNumber: this.pointNum,
        userKey: this.userKey,
        navigationName: this.gameParameters.navigationName,
      });
    },
    showAlertSkipPoint() {
      this.alertSkipPoint = true;
    },
    // dataURItoBlob(dataURI) {
    //   var byteString = atob(dataURI.split(",")[1]);
    //   var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    //   var ab = new ArrayBuffer(byteString.length);
    //   var ia = new Uint8Array(ab);
    //   for (var i = 0; i < byteString.length; i++) {
    //     ia[i] = byteString.charCodeAt(i);
    //   }
    //   var blob = new Blob([ab], { type: mimeString });
    //   return blob;
    // },
    stopLocationUpdates() {
      console.log(
        "stopLocationUpdates clicked this.watchPositionId",
        this.watchPositionId
      );
      this.showPosMarker = false;
      this.showCurrentPositionButton = true;
      navigator.geolocation.clearWatch(this.watchPositionId);
      console.log(
        "stopLocationUpdates clicked this.watchPositionId",
        this.watchPositionId
      );
    },
    showCurrentPosition() {
      if (navigator.geolocation) {
        console.log("navigator.geolocation OK");
        this.showCurrentPositionButton = false;
        this.watchPositionId = navigator.geolocation.watchPosition(
          (position) => {
            let pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            // console.log("position", position);
            this.myCurrentPosition = pos;
            // console.log("this.myCurrentPosition", this.myCurrentPosition);
            this.showPosMarker = true;
          },
          () => {
            handleLocationError(true, infoWindow, map.getCenter());
          },
          { enableHighAccuracy: true }
        );
      } else {
        // Browser doesn't support Geolocation
        alert("Browser doesn't support Geolocation");
        // handleLocationError(false, infoWindow, map.getCenter());
      }
    },

    translate(lang) {
      switch (lang) {
        case "fr":
          this.translationMissingWord = "Mot manquant sur l'image";
          this.translation = {
            back: "Fermer",
            skipPoint: "Passer au point suivant",
            skipPointBeware:
              "Attention! Si vous ne trouvez pas la pancarte, vous pouvez passer au point suivant, 10 minutes serons ajoutées à votre temps final.",
            mistakes: "Erreurs",
            runningTime: "Temps écoulé",
            map: "Carte",
            pointNumber: "Sur la carte, repérez le nº",
            goThere:
              "Rendez-vous sur place et trouvez l'inscription qui se trouve sur l'image ci-dessous.",
            didYouKnow: "Le saviez-vous?",
            goToQuestions: "Allons aux questions!",
            wellDone: "Bien joué!",
            correctAnswer: "C'est une bonne réponse!",
            continue: "Allez! On continue",
            wrongAnswer: "Ce n'est pas la bonne réponse.",
            tryAgain: "Essayons encore!",
            visitOf: "Nous espérons que vous avez apprécié votre visite de",
            yourResults: "Vos résultats sont:",
            errorNumber: "Nombre d'erreur:",
            totalTime: "Temps total:",
            goToRanking:
              "Avant de partir, vous pouvez aller jeter un coup d'oeil sur les résultats et voir en quelle positon vous êtes arrivés!",
          };
          break;
        case "en":
          this.translationMissingWord = "Missing word on the picture";
          this.translation = {
            back: "Fermer",
            skipPoint: "Passer au point suivant",
            skipPointBeware:
              "Attention! Si vous ne trouvez pas la pancarte, vous pouvez passer au point suivant, 10 minutes serons ajoutées à votre temps final.",
            mistakes: "Mistakes",
            runningTime: "Elapsed time",
            map: "Map",
            pointNumber: "On the map, find the nº",
            goThere: "Go there, and find this inscription ",
            didYouKnow: "Did you know?",
            goToQuestions: "Go to questions!",
            wellDone: "Well done!",
            correctAnswer: "The answer is correct!",
            continue: "Let’s continue…",
            wrongAnswer: "That's not the correct answer.",
            tryAgain: "Let's try again!",
            visitOf: "We hope you enjoyed your visit of",
            yourResults: "Your results are:",
            errorNumber: "Mistakes:",
            totalTime: "Total time:",
            goToRanking:
              "Before you leave, you can go take a look at the results and see where you are!",
          };

          // code block
          break;
        case "he":
          this.translationMissingWord = "מילה חסרה בתמונה";
          this.translation = {
            goToFirstPoint: "הגיעו לנקודה המופיעה על המפה",
            followThePath: "לכו על המסלול המופיע במפה",
            back: "לסגור",
            skipPoint: "לעבור לנקודה הבאה",
            skipPointBeware:
              "זהירות! אם אתם לא מוצאים את השלט, אתם יכולים לעבור לנקודה הבאה, 10 דקות יתווספו לזמן הסופי שלכם.",
            mistakes: "טעויות",
            runningTime: "זמן רץ",
            pointsScore: "נקודות",
            map: "מפה",
            pointNumber: "מצאו במפה את תחנה מספר",
            goThere: "לחצו על הכפתור כשהגעתם לנקודה",
            didYouKnow: "",
            goToQuestions: "לשאלות!",
            wellDone: "יפה מאוד!",
            correctAnswer: "הגעתם למקום הנכון",
            continue: "לחצו להמשך",
            wrongAnswer: "תשובה לא נכונה.",
            tryAgain: "ננסה שוב!",
            visitOf: "מקווים שנהנתם מהמשחק",
            yourResults: "התוצאות שלכם:",
            errorNumber: "טעויות:",
            totalTime: "סה''כ זמן:",
            goToRanking: "לפני שאתם מסיימים, אתם יכולים לראות באיזה מיקום אתם!",
            checkLocation: "הגעתי !",
          };
          // code block
          break;
        default:
        // code block
      }
    },
    // slideMapInn() {
    //   document.getElementById("map").className = "showMap";
    //   this.addMarker();
    // },
    // removeMap() {
    //   document.getElementById("map").classList.remove("showMap");
    // },
    fadeInDiv() {
      this.showPointInformation = false;
      this.showButtonInfoScreen = false;
      // this.rowPhotoMissingWord = false;
      // localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").className = "fadeIn";
      } else {
        console.log("[fadeInDiv] no questionDiv");
      }
    },
    countSeconds() {
      setInterval((_) => {
        this.timeNow = Date.now();
        this.totalSeconds = Math.floor((this.timeNow - this.startTime) / 1000);
        var pad = function (num, size) {
          return ("000" + num).slice(size * -1);
        },
          time = parseFloat(this.totalSeconds).toFixed(3),
          hours = Math.floor(time / 60 / 60),
          minutes = Math.floor(time / 60) % 60,
          seconds = Math.floor(time - minutes * 60);

        this.secondsToTime =
          pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
      }, 1000);
    },
    showResults() {
      // console.log("showResults");
      // localStorage.clear();
      this.$router.push("/results");
      // this.$store.dispatch("getResults", this.gameParameters.navigationName);
    },
    checkLocation() {
      console.log(
        "this.markers[this.pointNum].position.lat",
        this.markers[this.pointNum].position.lat
      );
      this.dialogCorrectAnswer = true;

      // let markerLat = this.markers[this.pointNum].position.lat;
      // let markerLng = this.markers[this.pointNum].position.lng;

      // if (navigator.geolocation) {
      //   this.watchPositionId = navigator.geolocation.getCurrentPosition(
      //     (position) => {
      //       let pos = {
      //         lat: position.coords.latitude,
      //         lng: position.coords.longitude,
      //       };
      //       this.myCurrentPosition = pos;
      //       console.log("position", position);
      //       console.log("this.myCurrentPosition", this.myCurrentPosition);
      //       if (
      //         markerLat > this.myCurrentPosition.lat - this.rangeInPosition &&
      //         markerLat < this.myCurrentPosition.lat + this.rangeInPosition &&
      //         markerLng > this.myCurrentPosition.lng - this.rangeInPosition &&
      //         markerLng < this.myCurrentPosition.lng + this.rangeInPosition
      //       ) {
      //         console.log("in the good range");
      //         this.dialogCorrectAnswer = true;
      //       } else {
      //         console.log("NOT in the good range");
      //         this.dialogWrongAnswer = true;
      //       }
      //     },
      //     () => {
      //       handleLocationError(true, infoWindow, map.getCenter());
      //     },
      //     { enableHighAccuracy: true }
      //   );
      // } else {
      //   // Browser doesn't support Geolocation
      //   alert("Browser doesn't support Geolocation");
      //   // handleLocationError(false, infoWindow, map.getCenter());
      // }
    },
    checkAnswer(answer) {
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").classList.remove("fadeIn");
      } else {
        console.log("[checkAnswer] No questionDiv");
      }
      if (answer === this.questionSuffled[this.questionNumber].correctAnswer) {
        if (
          Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
            .pointNumber == this.gameParameters.lastPoint
        ) {
          this.showLastDialog = true;
          // GET THE TOTAL TIME OF THE GAME
          this.endTime = Date.now();
          this.gameTimeInSecond = Math.floor(
            (this.endTime - this.startTime) / 1000
          );
          var pad = function (num, size) {
            return ("000" + num).slice(size * -1);
          },
            time = parseFloat(this.gameTimeInSecond).toFixed(3),
            hours = Math.floor(time / 60 / 60),
            minutes = Math.floor(time / 60) % 60,
            seconds = Math.floor(time - minutes * 60);

          this.gameSecondToTime =
            pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
          // SEND THE RESULTS TO THE DATABASE
          this.$store.dispatch("checkResults", {
            errorNumber: this.errorNumber,
            gameSecondToTime: this.gameSecondToTime,
            gameTimeInSecond: this.gameTimeInSecond,
          });
        } else {
          this.dialogCorrectAnswer = true;
        }
      } else {
        this.dialogWrongAnswer = true;
        this.errorNumber++;
        localStorage.setItem("errorNumber", this.errorNumber);
      }
    },
    hideImageQuestion() {
      localStorage.setItem("startTimeOuchui", this.startTime);
      // ADD A FADEINN CLASS TO THE QUESTION DIV
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").className = "fadeIn";
      } else {
      }
      // Here I check if I need to show the Information Page as per the game parameters
      this.dialogCorrectAnswer = false;
      if (this.gameParameters.infoPage === true && this.firstQuestion === 1) {
        this.showPointInformation = true;
        setTimeout((_) => {
          this.showButtonInfoScreen = true;
        }, 3000);
      }
      // ***********************************************ADDED THIS JUST FOR THE RANDOM QUESTIONS
      if (this.gameParameters.randomQuestions === true) {
        if (this.firstQuestion < this.numberOfQUestionPerPoint + 1) {
          this.questionNumber++;
          localStorage.setItem("questionNumber", this.questionNumber);
          // console.log("this.firstQuestion", this.firstQuestion)
          this.firstQuestion++;
          localStorage.setItem("firstQuestion", this.firstQuestion);
          // console.log("this.firstQuestion", this.firstQuestion)
          this.rowPhotoMissingWord = false;
          localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);
        } else {
          localStorage.setItem("questionNumber", this.questionNumber);
          this.rowPhotoMissingWord = !this.rowPhotoMissingWord;
          localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);

          if (this.rowPhotoMissingWord) {
            this.pointNum++;
            setTimeout(() => {
              this.addMarker();
            }, 1000);
            this.pointNumForEvolution++;
            localStorage.setItem("pointNumberOuchui", this.pointNum);
            localStorage.setItem(
              "pointNumForEvolutionOuchui",
              this.pointNumForEvolution
            );
            this.$store.dispatch("addEvolutionToDB", {
              pointNumber: this.pointNum,
              userKey: this.userKey,
              navigationName: this.gameParameters.navigationName,
            });
            this.firstQuestion = 1;
            localStorage.setItem("firstQuestion", 1);
          }
        }
      } else {
        // ******************************************************************************************
        if (
          Object.values(this.points)[this.pointsArrayOrder[this.pointNum] - 1]
            .pointNumber ==
          this.questionSuffled[this.questionNumber + 1].pointLinked
        ) {
          this.questionNumber++;
          localStorage.setItem("questionNumber", this.questionNumber);

          this.firstQuestion++;
          localStorage.setItem("firstQuestion", this.firstQuestion);

          this.rowPhotoMissingWord = false;
          localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);
        } else {
          localStorage.setItem("questionNumber", this.questionNumber);
          this.rowPhotoMissingWord = !this.rowPhotoMissingWord;
          localStorage.setItem("rowPhotoMissingWord", this.rowPhotoMissingWord);

          if (this.rowPhotoMissingWord) {
            this.pointNum++;
            setTimeout(() => {
              this.addMarker();
            }, 1000);
            this.pointNumForEvolution++;
            localStorage.setItem("pointNumberOuchui", this.pointNum);
            localStorage.setItem(
              "pointNumForEvolutionOuchui",
              this.pointNumForEvolution
            );

            this.$store.dispatch("addEvolutionToDB", {
              pointNumber: this.pointNum,
              userKey: this.userKey,
              navigationName: this.gameParameters.navigationName,
            });
            this.firstQuestion = 1;
            localStorage.setItem("firstQuestion", 1);
          }
        }
      }
    },
  },
};
</script>

<style scoped>
#timer {
  background: transparent;
  color: #605e5e;
  font-size: 22px;
  font-weight: bold;
}

.appearSlowly {
  -webkit-animation: appearingSlowly 5000ms;
  animation: appearingSlowly 5000ms;
}

@keyframes appearingSlowly {
  0% {
    opacity: 0;
  }

  30% {
    opacity: 1;
  }

  50% {
    opacity: 1;
  }

  70% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.textEncouragement {
  font-family: noot;
  color: chartreuse;
  position: absolute;
  top: 40vh;
  font-size: 40px;
  -webkit-text-stroke: 1px red;
  /* width and color */
  /* -webkit-animation: appearing 5000ms;
  animation: appearing 5000ms; */
  text-align: center;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

@keyframes appearing {
  0% {
    opacity: 0;
    font-size: 5px;
  }

  30% {
    opacity: 1;
    width: auto;
    height: auto;
  }

  80% {
    height: auto;
    opacity: 1;
    width: auto;
  }

  100% {
    opacity: 0;
    font-size: 5px;
  }
}

.sentenceAboveMap {
  text-align: center;
  width: 100%;
  font-size: 23px;
  font-weight: bold;
  color: var(--buttonColor);
}

.buttonStyle {
  left: 15px;
  padding-bottom: 15px;
  position: relative;
  bottom: 28px;
}

.buttonStyleNotThere {
  color: white;
  position: relative;
  font-weight: bold;
  font-size: 35px;
  background-color: red;
  padding: 10px;
  border-radius: 17px;
  animation: glowing 1300ms infinite;
}

.buttonStyleAlmostThere {
  color: white;
  position: relative;
  font-weight: bold;
  font-size: 35px;
  background-color: orangered;
  padding: 10px;
  border-radius: 17px;
  animation: glowing 1300ms infinite;
}

.checkLocationButtonDisabeld {
  font-size: 20px;
  padding-top: 35px;
  height: 100px;
  width: 100px;
  font-weight: bold;
  color: white;
  border-radius: 100px;
  /* background-color: var(--buttonColor); */
  /* -webkit-animation: glowing 1300ms infinite;
  animation: glowing 1300ms infinite; */
  border: 1px solid #999999;
  background-color: #cce3ca !important;
  color: #6666666b;
}

.checkLocationButton {
  font-size: 20px;
  padding-top: 35px;
  height: 100px;
  width: 100px;
  font-weight: bold;
  background-color: #9ceb95 !important;
  color: #1817176b;
  border-radius: 100px;
  /* background-color: var(--buttonColor); */
  -webkit-animation: glowing 1300ms infinite;
  animation: glowing 1300ms infinite;
}

@keyframes glowing {
  0% {
    /* background-color: #2ba805;
    box-shadow: 0 0 5px #2ba805; */
    background-color: var(--buttonColor);
    box-shadow: 0 0 5px var(--buttonColor);
  }

  50% {
    /* background-color: #49e819;
    box-shadow: 0 0 20px #49e819; */
    background-color: var(--buttonColor);
    box-shadow: 0 0 25px var(--buttonColor);
  }

  100% {
    /* background-color: #2ba805;
    box-shadow: 0 0 5px #2ba805; */
    background-color: var(--buttonColor);
    box-shadow: 0 0 5px var(--buttonColor);
  }
}

.mainButton {
  border-radius: 50px;
  height: 56px;
  color: white !important;
  display: block;
  margin: 0px auto;
  height: 90px !important;
  width: 90px;
  border: solid darkgreen 2px;
}

.currentPosButton {
  position: absolute;
  top: 61px;
  font-size: 19px;
  z-index: 100;
  color: green;
  left: 11px;
  direction: rtl;
  font-family: noot;
  background: white;
  border: 1px solid green;
  padding: 7px 8px 0px;
  border-radius: 5px;
}

#erreurs {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 28px);
}

#evolution {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 35px);
}

#runningTime {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 13px);
}

#carte {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 6px);
}

.center {
  display: block;
  margin: 0px auto;
}

#mapButton {
  width: 30px;
  position: absolute;
  top: 4px;
  right: -10px;
  margin-right: calc(50vw - 155px);
  font-size: 25px;
  color: white;
  /* border: solid 1px black; */
  width: 42px;
  height: 40px;
  padding: 5px;
  /* background: white; */
  z-index: 5;
}

#map {
  position: fixed;
  top: -100vh;
  right: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
  overflow: hidden;
  transition: all 1s;
}

#map2 {
  right: 0;
  width: 100vw;
  overflow: hidden;
  /* transition: all 1s; */
  border: solid 4px;
  border-color: var(--buttonColor);
  border-radius: 16px;
  background: transparent;
  /* animation: hueRotate 10s infinite linear; */
}

.showMap {
  position: fixed;
  top: 0 !important;
  right: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
  overflow: hidden !important;
  transition: all 1s;
}

#imgUrl {
  display: block;
  margin: 0 auto;
}

.errorsTimeMap {
  background: rgba(255, 255, 255, 1);
  border: none;
  font-size: 20px;
  padding-top: 5px;
}

.errorsTimeMap>svg {
  position: relative;
  bottom: 3px;
}

.pointNumber {
  margin: 0 auto;
  border: #d41a1b solid 2px;
  border-radius: 100px;
  height: 55px;
  width: 55px;
  font-size: 36px;
  padding-right: 1px;
  padding-top: 4px;
}

.rtl {
  direction: rtl;
}

.verticalAlign {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 80%;
}

.myModal {
  min-height: 200px;
  overflow: auto;
  width: 300px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  color: white;
}

.modalInformationPoint {
  box-shadow: none;
  border: solid rgb(9, 133, 235) 3px;
  margin-top: 1vh;
  width: 98vw;
  font-size: 22px;
  height: 98vh;
  overflow: auto;
  background: rgb(20, 186, 236);
  color: white;
}

.red {
  background-color: #d41a1b;
  border: solid white 2px;
}

.green {
  background-color: rgb(119, 190, 87);
  border: 2px white solid;
}

.over {
  position: absolute;
  top: 0px;
  font-size: 18px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 3;
}

.colorBtn {
  border-radius: 36px;
  min-height: 56px;
  color: white;
}

.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}

.question {
  text-align: center;
  font-family: "Assistant", sans-serif;
  font-weight: 400;
  font-size: 22px;
  color: black;
}

.btnAnswer {
  margin: 0 auto;
  width: 320px;
  height: 60px;
  border-radius: 35px;
  font-size: 20px;
  color: white;
  background: rgb(64, 150, 83) !important;
}

.title {
  font-size: 25px;
  text-align: right;
  color: black;
}

.userName {
  font-size: 18px;
  text-align: left;
  color: black;
}

.time {
  letter-spacing: 0.05em;
  font-size: 24px;
  font-family: "Cabin", sans-serif;
  text-align: center;
  color: rgb(14, 15, 14, 0.8);
}

.startTime {
  letter-spacing: 0.05em;
  font-size: 40px;
  padding: 5px 0;
  font-family: "Inconsolata", monospace;
  color: #ffffff;
  text-align: center;
  position: relative;
  left: 50%;
  margin-top: 50px;
  top: -24px;
  transform: translate(-50%, -50%);
  color: #daf6ff;
}

.hebrewText {
  text-align: right;
  font-size: 15px;
  padding-right: 5px;
  color: black;
}

.fadeIn {
  -webkit-animation: fadein 1s;
  /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s;
  /* Firefox < 16 */
  -ms-animation: fadein 1s;
  /* Internet Explorer */
  -o-animation: fadein 1s;
  /* Opera < 12.1 */
  animation: fadein 1s;
}

.confetti {
  width: 15px;
  height: 15px;
  background-color: #b1f70f;
  position: absolute;
  left: 50%;
  animation: confetti 5s ease-in-out -2s infinite;
  transform-origin: left top;
}

.confetti:nth-child(1) {
  background-color: #faf623;
  left: 10%;
  animation-delay: 0;
}

.confetti:nth-child(2) {
  background-color: #129dee;
  left: 20%;
  animation-delay: -5s;
}

.confetti:nth-child(3) {
  background-color: #e21f0d;
  left: 30%;
  animation-delay: -3s;
}

.confetti:nth-child(4) {
  background-color: #f1dc6f;
  left: 40%;
  animation-delay: -2.5s;
}

.confetti:nth-child(5) {
  background-color: #039cf5;
  left: 50%;
  animation-delay: -4s;
}

.confetti:nth-child(6) {
  background-color: #f52916;
  left: 60%;
  animation-delay: -6s;
}

.confetti:nth-child(7) {
  background-color: #5cf24e;
  left: 70%;
  animation-delay: -1.5s;
}

.confetti:nth-child(8) {
  background-color: #d717e9;
  left: 80%;
  animation-delay: -2s;
}

.confetti:nth-child(9) {
  background-color: #f30e34;
  left: 90%;
  animation-delay: -3.5s;
}

.confetti:nth-child(10) {
  background-color: #7cf24e;
  left: 100%;
  animation-delay: -2.5s;
}

.confetti:nth-child(11) {
  background-color: #f52916;
  left: 15%;
  animation-delay: -6.5s;
}

.confetti:nth-child(12) {
  background-color: #5cf24e;
  left: 25%;
  animation-delay: -1.8s;
}

.confetti:nth-child(13) {
  background-color: #d717e9;
  left: 75%;
  animation-delay: -2.5s;
}

.confetti:nth-child(14) {
  background-color: #f30e34;
  left: 85%;
  animation-delay: -3.8s;
}

.confetti:nth-child(15) {
  background-color: #7cf24e;
  left: 55%;
  animation-delay: -4.2s;
}

.confetti:nth-child(16) {
  background-color: #d717e9;
  left: 75%;
  animation-delay: -3.5s;
}

.confetti:nth-child(18) {
  background-color: #f30e34;
  left: 85%;
  animation-delay: -6.8s;
}

.confetti:nth-child(17) {
  background-color: #7cf24e;
  left: 55%;
  animation-delay: -4.9s;
}

@keyframes confetti {
  0% {
    transform: rotateZ(15deg) rotateY(0deg) translate(0, 0);
  }

  25% {
    transform: rotateZ(5deg) rotateY(360deg) translate(-5vw, 20vh);
  }

  50% {
    transform: rotateZ(15deg) rotateY(720deg) translate(7vw, 60vh);
  }

  75% {
    transform: rotateZ(5deg) rotateY(1080deg) translate(-25vw, 80vh);
  }

  100% {
    transform: rotateZ(15deg) rotateY(1440deg) translate(20vw, 110vh);
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@font-face {
  font-family: noot;
  src: url(../../static/fonts/Noot/noot-aj.woff);
}

.dot-pulse {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--buttonColor);
  color: var(--buttonColor);
  box-shadow: 9999px 0 0 -5px var(--buttonColor);
  animation: dotPulse 1.5s infinite linear;
  animation-delay: 0.25s;
}

.dot-pulse::before,
.dot-pulse::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--buttonColor);
  color: var(--buttonColor);
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px var(--buttonColor);
  animation: dotPulseBefore 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px var(--buttonColor);
  animation: dotPulseAfter 1.5s infinite linear;
  animation-delay: 0.5s;
}

@keyframes dotPulseBefore {
  0% {
    box-shadow: 9984px 0 0 -5px var(--buttonColor);
  }

  30% {
    box-shadow: 9984px 0 0 2px var(--buttonColor);
  }

  60%,
  100% {
    box-shadow: 9984px 0 0 -5px var(--buttonColor);
  }
}

@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px var(--buttonColor);
  }

  30% {
    box-shadow: 9999px 0 0 2px var(--buttonColor);
  }

  60%,
  100% {
    box-shadow: 9999px 0 0 -5px var(--buttonColor);
  }
}

@keyframes dotPulseAfter {
  0% {
    box-shadow: 10014px 0 0 -5px var(--buttonColor);
  }

  30% {
    box-shadow: 10014px 0 0 2px var(--buttonColor);
  }

  60%,
  100% {
    box-shadow: 10014px 0 0 -5px var(--buttonColor);
  }
}

.g-container {
  position: relative;
  width: 300px;
  height: 170px;
  margin: auto;
}

/* .g-contrast {
  filter: contrast(10) hue-rotate(0);
  width: 300px;
  height: 300px;
  background-color: transparent;
  overflow: hidden;
  animation: hueRotate 10s infinite linear;
} */

.g-circle {
  position: relative;
  width: 300px;
  height: 250px;
  box-sizing: border-box;
  /* filter: blur(1px); */
}

.g-circle::after {
  content: "";
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(0);
  width: 120px;
  height: 120px;
  background-color: var(--buttonColor);
  /* filter: contrast(10) hue-rotate(0); */
  border-radius: 42% 38% 62% 49% / 45%;
  animation: rotate 10s infinite linear;
}

.g-bubbles {
  position: absolute;
  left: 50%;
  top: -2px;
  width: 47px;
  height: 13px;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  border-radius: 0px 0px 179px 193px;
  background-color: var(--buttonColor);
  /* -webkit-filter: blur(3px);
  filter: blur(1px); */
}

#explosionDiv {
  position: absolute;
  left: 47%;
  top: 69px;
  width: 0px;
  height: 0px;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  background-color: green;
  z-index: 3;
}

.explosion {
  border-radius: 50%;
  background-color: green;
  position: absolute;
  transform: translate(-50%, -50%);
  animation: explosionAnimation 1s ease-out -infinite;
  z-index: 50;
}

.explosion:nth-child(1) {
  width: 8x;
  height: 8x;
  left: 10px;
  animation-delay: -3s;
  animation: explosionAnimation 0.5s ease-out infinite;
}

.explosion:nth-child(2) {
  width: 9px;
  height: 9px;
  left: 18px;
  animation-delay: -4s;
  animation: explosionAnimation 1s ease-out infinite;
}

.explosion:nth-child(3) {
  width: 6px;
  height: 6px;
  left: 32px;
  animation-delay: -5s;
  animation: explosionAnimation 0.7s ease-out infinite;
}

.explosion:nth-child(4) {
  width: 10px;
  height: 10px;
  left: 27px;
  animation-delay: -2s;
  animation: explosionAnimation 0.6s ease-out infinite;
}

.explosion:nth-child(5) {
  width: 5px;
  height: 5px;
  left: 20px;
  animation-delay: -5s;
  animation: explosionAnimation 0.8s ease-out infinite;
}

.explosion:nth-child(6) {
  width: 4px;
  height: 4x;
  left: 35px;
  animation-delay: -6s;
  animation: explosionAnimation 0.4s ease-out infinite;
}

.explosion:nth-child(7) {
  width: 8x;
  height: 8x;
  top: 50px;
  left: 0px;
  /*left: 10px;*/
  animation-delay: -3s;
  animation: ballsToScore 0.5s ease-out infinite;
}

.explosion:nth-child(8) {
  width: 9px;
  height: 9px;
  top: 50px;
  left: 0px;
  /*left: 18px;*/
  animation-delay: -4s;
  animation: ballsToScore 1s ease-out infinite;
}

.explosion:nth-child(9) {
  width: 6px;
  height: 6px;
  top: 50px;
  left: 0px;
  /*left: 32px;*/
  animation-delay: -5s;
  animation: ballsToScore 0.7s ease-out infinite;
}

.explosion:nth-child(10) {
  width: 10px;
  height: 10px;
  top: 50px;
  left: 0px;
  /*left: 27px;*/
  animation-delay: -2s;
  animation: ballsToScore 0.6s ease-out infinite;
}

.explosion:nth-child(11) {
  width: 5px;
  height: 5px;
  top: 50px;
  left: 0px;
  /*left: 20px;*/
  animation-delay: -5s;
  animation: ballsToScore 0.8s ease-out infinite;
}

.explosion:nth-child(12) {
  width: 4px;
  height: 4x;
  top: 50px;
  left: 0px;
  /*left: 35px;*/
  animation-delay: -6s;
  animation: ballsToScore 0.4s ease-out infinite;
}

.bubbles {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  background-color: var(--buttonColor);
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: moveToTop 1s ease-in-out -infinite;
}

.bubbles:nth-child(1) {
  width: 12x;
  height: 12x;
  left: 35px;
  animation-delay: -3s;
  animation: moveToTop 3s ease-in-out infinite;
}

.bubbles:nth-child(2) {
  width: 18px;
  height: 18px;
  left: 18px;
  animation-delay: -4s;
  animation: moveToTop 5s ease-in-out infinite;
}

.bubbles:nth-child(3) {
  width: 6px;
  height: 6px;
  left: 32px;
  animation-delay: -5s;
  animation: moveToTop 4s ease-in-out infinite;
}

.bubbles:nth-child(4) {
  width: 10px;
  height: 10px;
  left: 27px;
  animation-delay: -2s;
  animation: moveToTop 2s ease-in-out infinite;
}

/* .bubbles:nth-child(5) {
  width: 31px;
  height: 31px;
  left: 20px;
  animation-delay: -5s;

  animation: moveToTop 2s ease-in-out - 2s infinite;
}
.bubbles:nth-child(6) {
  width: 19px;
  height: 19x;
  left: 35px;
  animation-delay: -6s;

  animation: moveToTop 2s ease-in-out - 2s infinite;
}
.bubbles:nth-child(7) {
  width: 8px;
  height: 8px;
  left: 20px;
  animation-delay: -7s;

  animation: moveToTop 2s ease-in-out - 2s infinite;
}
.bubbles:nth-child(8) {
  width: 35px;
  height: 35px;
  left: 50px;
  animation-delay: -10s;

  animation: moveToTop 2s ease-in-out - 2s infinite;
}
.bubbles:nth-child(9) {
  width: 20px;
  height: 20px;
  left: 5px;
  animation-delay: -3s;

  animation: moveToTop 2s ease-in-out - 2s infinite;
}
.bubbles:nth-child(10) {
  width: 26px;
  height: 26px;
  left: 34px;
  animation-delay: -6s;

  animation: moveToTop 2s ease-in-out - 2s infinite;
}
.bubbles:nth-child(11) {
  width: 18px;
  height: 18px;
  left: 28px;
  animation-delay: -7s;

  animation: moveToTop 2s ease-in-out - 2s infinite;
}
.bubbles:nth-child(12) {
  width: 42px;
  height: 42px;
  left: 42px;
  animation-delay: -9s;

  animation: moveToTop 2s ease-in-out - 2s infinite;
} */

/* @for $i from 0 through 15 {
  li:nth-child(#{$i}) {
    $width: 15 + random(15) + px;
    left: 15 + random(70) + px;
    top: 50%;
    transform: translate(-50%, -50%);
    width: $width;
    height: $width;
    animation: moveToTop  #{random(6) + 3}s ease-in-out -#{random(5000) / 1000}s
      infinite;
  }
} */

@keyframes rotate {
  50% {
    border-radius: 45% / 42% 38% 58% 49%;
  }

  100% {
    transform: translate(-50%, -50%) rotate(720deg);
  }
}

@keyframes moveToTop {
  90% {
    opacity: 1;
  }

  100% {
    opacity: 0.1;
    transform: translate(-55%, 30px);
  }
}

@keyframes ballsToScore {
  90% {
    opacity: 1;
  }

  100% {
    opacity: 0.1;
    transform: translate(-110px, 150px);
  }
}

@keyframes explosionAnimation {
  60% {
    opacity: 1;
    transform: translate(20px, -40px);
  }

  90% {
    opacity: 1;
  }

  100% {
    opacity: 0.1;
    transform: translate(38px, -5px);
  }
}

@keyframes hueRotate {
  100% {
    /* filter: contrast(0) hue-rotate(360deg); */
    filter: contrast(15) hue-rotate(360deg);
  }
}
</style>
